export function newModalStore() {
    return {
        state: {
            loading: false,
            page: 1,
            pageCount: 0,
            //filter: {},

            isVisible: false,

            showLoadingModal: false,
            showAlertModal: false,
            modalTitle: "Tittle default",
            modalDescription: "Header default",
            cancelButtons: [ {
                id: 'cancel',
                label: 'lbl.basic.cancel'
            }
            ],
            confirmButtons: [ {
                id: 'yes',
                label: 'lbl.basic.yes'
            }
            ]
        },
        getters: {
            page: state => state.page,
            pageCount: state => state.pageCount
        },
        actions: {
            confirmModal(context, buttonId) {
                //Used by modal plugin
                return;
            },
            cancelModal(context, buttonId) {
                //Used by modal plugin
                return;
            }
        },
        mutations: {
            //Controls the "Loading" state of the application,
            //e.g. when retrieving data from an API
            setModalDescription(state, modalDescription) {
                state.modalDescription = modalDescription;
            },
            setIsVisible(state, visible) {
                state.isVisible = visible
            }
        }
    }

}